import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";
import { ShoppingBag } from "lucide-react";

export default function MerchPreview({ limit = 4 }) {
  const [products, setProducts] = useState([]);
  const { add } = useCart();

  useEffect(() => {
    api.get("/products").then((r) => setProducts((r.data.products || []).slice(0, limit))).catch(() => {});
  }, [limit]);

  return (
    <section className="py-20 px-6 md:px-12 lg:px-16 bg-white border-t border-border" data-testid="merch-preview">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="text-halo-red font-sports uppercase tracking-[0.3em] text-xs mb-3">Official Gear</div>
            <h2 className="font-sports uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-halo-navy">
              Rep Our <span className="text-halo-red">Gear</span>
            </h2>
          </div>
          <Link
            to="/shop" data-testid="view-all-merch-btn"
            className="inline-flex items-center gap-2 border-2 border-halo-navy text-halo-navy hover:bg-halo-navy hover:text-halo-cream px-5 py-3 font-sports uppercase tracking-wider text-xs"
          >
            <ShoppingBag className="w-4 h-4" strokeWidth={2.5} />
            View All Merch →
          </Link>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {products.map((p) => (
            <div
              key={p.id}
              data-testid={`merch-card-${p.id}`}
              className="group bg-white border border-border hover:-translate-y-1 transition-transform duration-300 flex flex-col"
            >
              <div className="aspect-square overflow-hidden bg-halo-cream">
                {p.image_position ? (
                  <div
                    className="w-full h-full transition-transform duration-500 group-hover:scale-105"
                    style={{
                      backgroundImage: `url(${p.image})`,
                      backgroundSize: "200% auto",
                      backgroundPosition: "left center",
                      backgroundRepeat: "no-repeat",
                      backgroundColor: "#000",
                    }}
                    role="img"
                    aria-label={p.name}
                  />
                ) : (
                  <img src={p.image} alt={p.name} loading="lazy"
                       className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                )}
              </div>
              <div className="p-4 flex flex-col gap-3 flex-1">
                <div className="flex-1">
                  <div className="text-[10px] font-sports uppercase tracking-widest text-halo-red">{p.category}</div>
                  <h3 className="font-sports uppercase tracking-tight text-lg leading-tight mt-1 text-halo-navy">{p.name}</h3>
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-sports text-2xl text-halo-navy">${p.price.toFixed(2)}</span>
                  <button
                    data-testid={`add-to-cart-${p.id}`}
                    onClick={() => { add(p, 1); toast.success(`${p.name} added`); }}
                    className="bg-halo-navy text-halo-cream hover:bg-halo-red p-2 transition-colors"
                    aria-label="Add to cart"
                  >
                    <ShoppingBag className="w-4 h-4" strokeWidth={2.5} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
